import React, { useState } from "react";
import { MapPin, User, Phone, Home } from "lucide-react";
import { LOCALITIES } from "../mock";
import { useToast } from "../hooks/use-toast";

const PickupBar = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ locality: "", name: "", mobile: "", address: "" });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const valid = form.name.trim() && /^\d{10}$/.test(form.mobile) && form.locality;

  const submit = () => {
    const existing = JSON.parse(localStorage.getItem("laundryma_bookings") || "[]");
    localStorage.setItem("laundryma_bookings", JSON.stringify([{ ...form, id: Date.now(), createdAt: new Date().toISOString() }, ...existing]));
    toast({ title: "Pickup requested!", description: "Our representative will call you shortly to confirm your slot." });
    setForm({ locality: "", name: "", mobile: "", address: "" });
  };

  return (
    <section className="relative -mt-2 z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 sm:p-8">
          <div className="text-center mb-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-navy font-head">Laundry &amp; Dry Clean Pickup — <span className="text-orange-brand">Absolutely Free</span></h2>
            <p className="text-navy/60 text-sm mt-2">As affordable as soap and water, but way better!</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <BarField icon={MapPin}>
              <select value={form.locality} onChange={(e) => set("locality", e.target.value)} className="w-full outline-none bg-transparent text-sm text-navy">
                <option value="">Location</option>
                {LOCALITIES.map((l) => <option key={l} value={l}>{l}</option>)}
              </select>
            </BarField>
            <BarField icon={User}>
              <input value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Name" className="w-full outline-none bg-transparent text-sm" />
            </BarField>
            <BarField icon={Phone}>
              <input value={form.mobile} maxLength={10} onChange={(e) => set("mobile", e.target.value.replace(/\D/g, ""))} placeholder="Mobile Number" className="w-full outline-none bg-transparent text-sm" />
            </BarField>
            <BarField icon={Home}>
              <input value={form.address} onChange={(e) => set("address", e.target.value)} placeholder="Address" className="w-full outline-none bg-transparent text-sm" />
            </BarField>
          </div>
          <div className="text-center mt-6">
            <button onClick={submit} disabled={!valid}
              className="bg-orange-brand disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#e0850f] text-white font-semibold px-10 py-3.5 rounded-full shadow-lg shadow-orange-brand/25 transition-colors">
              Book Pickup Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const BarField = ({ icon: Icon, children }) => (
  <div className="flex items-center gap-2.5 border border-gray-200 rounded-xl px-3.5 py-3 focus-within:border-navy transition-colors">
    <Icon size={18} className="text-orange-brand shrink-0" />
    {children}
  </div>
);

export default PickupBar;
